import { httpClient } from "./httpClient";
import { Rating } from "./types/rating";

export const submitRating = async (
  rating: Rating
): Promise<{ success: boolean }> => {
  try {
    const { data } = await httpClient.put<{ success: boolean }>(
      `/api/v1/request/rating`,
      { ...rating }
    );
    return data;
  } catch (err) {
    console.error("Error: ", err);
    return { success: false };
  }
};
